/**
 * ECharts Option Builder — Funnel chart.
 */
import type { EChartsOption } from 'echarts';
import { type ChartTheme, buildBaseOption, tooltipConfig, legendConfig } from '../theme';
import type { ChartData } from '../../../../api/types';
import { colIdx } from './utils';

export function buildFunnelChart(
  data: ChartData,
  theme: ChartTheme,
  animated: boolean,
): EChartsOption {
  const meta = data.meta;
  const nameIdx = colIdx(data, meta?.x ?? data.columns[0].name);
  const valueIdx = colIdx(data, meta?.y?.[0] ?? data.columns[1]?.name ?? data.columns[0].name);

  const funnelData = data.rows.map((row) => ({
    name: String(row[nameIdx] ?? ''),
    value: row[valueIdx] ?? 0,
  }));

  return {
    ...buildBaseOption(theme, animated),
    tooltip: tooltipConfig(theme, 'item'),
    legend: { ...legendConfig(theme), top: 0 },
    series: [
      {
        type: 'funnel',
        sort: 'none' as const,
        gap: 1,
        data: funnelData,
        minSize: '20%',
        maxSize: '80%',
        label: { show: true, position: 'inside', color: '#fff' },
        emphasis: { focus: 'none' as const },
      },
    ],
  };
}